<template lang="pug">
.a_2_Upper
    //- r4k in base.sass
    //- used for 4k resolution
    .r4k
        Content



</template>
<script>
//import axios from 'axios'
import FontService from '@/services/FontService'
import KeyService from '@/services/KeyService'
import Content from './A_2_UpperContent'
//const config = './static/M/M_1/'
export default {
    data(){
        return{
            //configLoaded: false,
            //assets: null
        }
    },
    components:{
        Content

    },
    mounted(){
        // load config
        /*axios.get(config).then(response=>{
            const result = response.data
            //this.something = data
            this.assets = result.assets
        })*/
        // set up resize service and keyservice
        FontService.getInstance()
        KeyService.getInstance().add('c', this.showControl)
        KeyService.getInstance().updateF(this.$el)
      
    },
    methods:{
        showControl(){
            console.log('add your control here like following')
            //window.open('/#/D1_3_Control','_blank')
        },
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.a_2_Upper
    +full()
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    background: black
    .r4k
        background: black
        .hello
            position: relative
            color: red

</style>